import React from "react"
import type { Translations } from "./useTranslations"

export interface TranslationsContextProps {
	isLoaded: boolean
	translations: Translations | undefined
}

const initialTranslationsContext: TranslationsContextProps = {
	isLoaded: false,
	translations: undefined,
}

export const TranslationsContext = React.createContext<TranslationsContextProps>(initialTranslationsContext)
